import React from "react";
import Select from "antd/es/select/index";
import { useTranslation } from "react-i18next";
import countryCodes from "../../config/countries";

const PhoneCountryCodeSelect = ({
  width = "100%",
  showCountryName = true,
  ...props
}) => {
  const { i18n } = useTranslation();
  const getCountryName = (code) => {
    return i18n.language === "es" ? code.name_es : code.name_en;
  };
  return (
    <Select defaultValue="+54" style={{ width }} {...props}>
      {countryCodes().map((code) => {
        return (
          <Select.Option key={code.code} value={code.dial_code}>
            {showCountryName && getCountryName(code)} {code.dial_code}
          </Select.Option>
        );
      })}
    </Select>
  );
};

export default PhoneCountryCodeSelect;
